import { SVGProps } from 'react';

const SvgLogoRedSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.872} y={0.5} width={50} height={50} rx={3} fill="#FE3B1F" />
    <g clipPath="url(#logo-red-square_svg__a)">
      <path
        d="M19.177 27.98c-.176.568-.442 1.046-.825 1.434a3.908 3.908 0 0 1-1.416.927c-.59.209-1.268.328-2.064.328h-1.386c-.796 0-1.474-.12-2.064-.328a3.463 3.463 0 0 1-1.416-.927c-.383-.388-.648-.866-.825-1.434a6.305 6.305 0 0 1-.266-1.882v-1.674c0-.717.089-1.344.266-1.912a3.767 3.767 0 0 1 .825-1.464 3.907 3.907 0 0 1 1.416-.926c.59-.21 1.268-.329 2.064-.329h1.386c.796 0 1.474.12 2.064.329.59.209 1.062.538 1.416.926.383.388.649.896.825 1.464.178.568.266 1.195.266 1.912v1.674c.03.687-.059 1.315-.266 1.882Zm-7.903.598c.413.478 1.091.717 2.035.717h1.799c.944 0 1.622-.24 2.035-.717.413-.478.59-1.165.59-2.122v-2.45c0-.956-.207-1.643-.59-2.121-.413-.479-1.091-.688-2.035-.688h-1.799c-.944 0-1.622.24-2.035.688-.412.478-.619 1.165-.619 2.121v2.45c0 .957.207 1.674.62 2.122ZM28.673 30.879c-.442 0-.796-.12-1.09-.359a4.555 4.555 0 0 1-.738-.896l-3.568-5.827a1.045 1.045 0 0 0-.177-.269c-.03-.03-.03-.03-.06-.03-.058 0-.088.03-.088.03-.03.03-.03.12-.03.21v6.991h-1.621v-6.932c0-.508.118-.956.383-1.315.266-.388.708-.567 1.298-.567.413 0 .766.12 1.061.388.266.239.531.568.797 1.016l3.48 5.737c.058.09.117.18.176.21.03.029.06.059.089.059.059 0 .059-.03.088-.03.03-.03.03-.09.03-.15v-7.081h1.592v7.022c0 .538-.147.956-.413 1.285-.265.328-.678.508-1.209.508ZM39.968 33H35.19c-1.592 0-2.86-1.315-2.86-2.898v-9.204c0-1.613 1.297-2.898 2.86-2.898h4.748c1.593 0 2.86 1.315 2.86 2.898v9.174c.03 1.613-1.267 2.928-2.83 2.928Z"
        fill="#fff"
      />
      <path
        d="M37.874 30.878H34.394v-2.15h3.568c.354-.06.62-.3.679-.599 0-.06.03-.12.03-.149 0-.837-1.505-1.404-2.124-1.972v-.956c.62-.568 2.123-1.195 2.123-1.972 0-.06 0-.12-.03-.15a.758.758 0 0 0-.648-.597h-3.598V20.15H38.051c1.268.09 2.359 1.016 2.595 2.241.03.18.059.359.059.568a2.74 2.74 0 0 1-1.268 2.33l-.265.21.265.21c.796.537 1.268 1.403 1.268 2.33 0 .18-.03.388-.059.568a2.871 2.871 0 0 1-2.595 2.24c-.03.03-.118.03-.177.03Z"
        fill="#1D252C"
      />
    </g>
    <defs>
      <clipPath id="logo-red-square_svg__a">
        <path
          fill="#fff"
          transform="translate(8.915 18)"
          d="M0 0h33.913v15H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgLogoRedSquare;
